<template>
  <component :is="component" :model="model" :id="id"></component>
</template>

<script>
import Item from '@/components/changelog/Item'
import Persons from '@/components/changelog/Persons'
import Sessions from '@/components/changelog/Sessions'
import Presentations from '@/components/changelog/Presentations'
import Participations from '@/components/changelog/Participations'
import Picture from '@/components/changelog/Picture'
import Abstracts from '@/components/changelog/Abstracts'
import Funding from '@/components/changelog/Funding'
import Mail from '@/components/changelog/Mail'
export default {
  components: {
    Item,
    Persons,
    Sessions,
    Presentations,
    Participations,
    Picture,
    Abstracts,
    Funding,
    Mail,
  },
  props: ['model', 'id'],
  computed: {
    component: function () {
      let component = '';
      if (this.$route.path.match(/edit$/)) component = 'Item';
      if (this.$route.path.match(/persons$/)) component = 'Persons';
      if (this.$route.path.match(/sessions$/)) component = 'Sessions';
      if (this.$route.path.match(/presentations$/)) component = 'Presentations';
      if (this.$route.path.match(/participations$/)) component = 'Participations';
      if (this.$route.path.match(/picture$/)) component = 'Picture';
      if (this.$route.path.match(/abstracts$/)) component = 'Abstracts';
      if (this.$route.path.match(/funding$/)) component = 'Funding';
      if (this.$route.path.match(/mail$/)) component = 'Mail';
      return component;
    }
  }
}
</script>